import React, { useState } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { Title, Text, CheckoutForm} from 'ui';
import { updatePayment } from 'api';
import "./index.css";


export default function Payment() {
  
  const history = useHistory();
  const match = useRouteMatch();
  const companyId = match.params.companyId;
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  
  async function save(token) {
    if(submitting) {
      return;
    }
    setSubmitting(true);
    try {
      await updatePayment({
        companyId: companyId,
        token,
      });
    }
    catch(error) {
      console.error(error);
      setError(error.message || "Something went wrong. Please try again.");
      setSubmitting(false);
      return;
    }
    history.push('view');
  }
  
  function cancel() {
    history.push('view');
  }
  
  return (
    <div className="companypayment">
    
      <Title>Update Payment</Title>
      
      <Text small color="red">{error}</Text>
      
      <CheckoutForm 
        onSubmit={save} 
        onCancel={cancel}
        submitting={submitting}
      />
      
    </div>
  );
}